<template>
  <div class="select-modal">
    <a-modal
      :title="$t('chooseBooth.add_booth')"
      :visible="selectModalVisible"
      :destroy-on-close="true"
      :width="480"
      :cancel-text="$t('chooseBooth.close_btn')"
      :ok-text="$t('chooseBooth.next_step')"
      @ok="handleSuccess"
      @cancel="handleCancel"
    >
      <a-radio-group v-if="showAddType==='select'" v-model="value">
        <a-radio :style="radioStyle" value="boothAdd">
          {{ $t('chooseBooth.booth_add') }}
        </a-radio>
        <a-radio :style="radioStyle" value="exhibitorsAdd">
          {{ $t('chooseBooth.exhibitors_add') }}
        </a-radio>
      </a-radio-group>
      <template slot="footer">
        <div v-if="showAddType==='select'">
          <a-button key="back" @click="handleCancel">
            {{ $t('chooseBooth.return') }}
          </a-button>
          <a-button key="submit" type="primary" @click="handleSuccess">
            {{ $t('chooseBooth.next_step') }}
          </a-button>
        </div>
        <div v-if="showAddType==='boothAdd'" style=" display: flex;justify-content: space-between;">
          <div>
            <a-button key="back" @click="showAddType='select'">
              {{ $t('chooseBooth.previous') }}
            </a-button>
          </div>
          <div>
            <a-button key="back" @click="handleCancel">
              {{ $t('chooseBooth.return') }}
            </a-button>
            <a-button key="submit" type="primary" @click="boothAddClick">
              {{ $t('chooseBooth.relate_btn') }}
            </a-button>
          </div>
        </div>
        <div v-if="showAddType==='exhibitorsAdd'" style=" display: flex;justify-content: space-between;">
          <div>
            <a-button key="back" @click="showAddType='select'">
              {{ $t('chooseBooth.previous') }}
            </a-button>
          </div>
          <div>
            <a-button key="back" @click="handleCancel">
              {{ $t('chooseBooth.return') }}
            </a-button>
            <a-button key="submit" type="primary" @click="exhibitionsAddClick">
              {{ $t('chooseBooth.relate_btn') }}
            </a-button>
          </div>
        </div>
      </template>
      <BoothAdd v-if="showAddType==='boothAdd'" ref="exhibitionBoothAdd" @handleCancel="handleCancel" @Refresh="Refresh" />
      <ExhibitorsAdd v-if="showAddType==='exhibitorsAdd'" ref="exhibitorsAdd" @handleCancel="handleCancel" />
    </a-modal>
  </div>
</template>

<script>
import ExhibitorsAdd from './ExhibitorsAdd.vue'
import BoothAdd from './BoothAdd.vue'
export default {
  name: 'SelectModal',
  components: {
    BoothAdd, ExhibitorsAdd
  },
  props: {
    selectModalVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      value: 'boothAdd',
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px'
      },
      showAddType: 'select',
      exhibitionId: sessionStorage.getItem('exhibitionId')
    }
  },
  methods: {
    handleSuccess() {
      this.showAddType = this.value
    },
    handleCancel(e) {
      this.$emit('handleCancel', () => { })
    },
    Refresh() {
      this.$emit('handleOk', () => { })
    },
    boothAddClick() {
      this.$refs.exhibitionBoothAdd.boothAddClick()
    },
    exhibitionsAddClick() {
      const items = this.$refs.exhibitorsAdd.getExhibitionsItemList()
      if (items.length === 0) {
        this.$message.error(this.$t('shopList.至少选择一个展位进行添加'))
        return false
      }
      this.$http.post(this.api + `a/api/project/booth/batch/bindBooth?exhibitionId=${this.exhibitionId}`, [...items]).then(res => {
        if ((res.data.resultCode === 0 || res.data.resultCode === '0') && res.data.data && res.data.data.length > 0) {
          this.$message.success(this.$t('shopList.绑定展位成功'))
          this.$emit('handleOk', () => { })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/fee/UseBooth/SelectModal.vue